export default __webpack_public_path__ + "static/media/shop.af95488a.jpg";